export default "__VITE_ASSET__78MwQkIj__"